<template>
  <span class="fs-9 text-uppercase text-gray-700 fw-bold">
    <slot></slot>
  </span>
</template>
